export default __webpack_public_path__ + "static/icon-sniffing-dog-7bf10e014ad6e5ac08f83386e084f8ee.png";